import React, { createContext, FC, useState } from 'react';

interface IManageVendorPageProps {
  setSelectedSort: (val: string) => void;
  selectedSort: string;
  sortDirection: {
    Phone?: 'Asc' | 'Desc';
    Fax?: 'Asc' | 'Desc';
    Name?: 'Asc' | 'Desc';
    SageId?: 'Asc' | 'Desc';
    IsActive?: 'Asc' | 'Desc';
    SubcontractorType?: 'Asc' | 'Desc';
    VendorType?: 'Asc' | 'Desc';
    UserCount?: 'Asc' | 'Desc';
  };
  setSortDirection: (val: any) => void;
  setSearchValue: (val: string) => void;
  setSearchedValue: (val: string) => void;
  searchValue: string;
  selectedTypeId: string;
  setSelectedTypeId: (val: any) => void;
  selectedVendorTypeIds: string[];
  setSelectedVendorTypeIds: (val: any[]) => void;
  setRowsPerPage: (val: number) => void;
  setPage: (val: number) => void;
  setRecordCount: (val: number) => void;
  page: number;
  recordCount: number;
  perPage: number;
  searchedValue: string;
  hasAppliedFilters: boolean;
  setHasAppliedFilters: (val: boolean) => void;
  setFilters: (
    val: {
      typeId?: number | string;
      vendorTypeIds?: string[];
    } | null
  ) => void;
  filters: {
    typeId?: number | string;
    vendorTypeIds?: string[];
  } | null;
}

export const ManageVendorPageContext = createContext<IManageVendorPageProps>({
  setSortDirection: () => {},
  setSelectedSort: () => {},
  setSearchValue: () => {},
  setSearchedValue: () => {},
  setSelectedVendorTypeIds: () => {},
  setSelectedTypeId: () => {},
  setRowsPerPage: () => {},
  setRecordCount: () => {},
  setPage: () => {},
  setHasAppliedFilters: () => {},
  setFilters: () => {},
  hasAppliedFilters: false,
  selectedSort: '',
  sortDirection: {
    Name: 'Asc'
  },
  page: 0,
  recordCount: 0,
  perPage: 10,
  selectedTypeId: '',
  selectedVendorTypeIds: [],
  searchedValue: '',
  searchValue: '',
  filters: {}
});

interface IManageVendorPageContextHandlerProps {}

export const ManageVendorPageContextHandler: FC<IManageVendorPageContextHandlerProps> = ({ children }): JSX.Element => {
  const [selectedSort, setSelectedSort] = useState<string>('Name');
  const [sortDirection, setSortDirection] = useState<{
    Phone?: 'Asc' | 'Desc';
    Fax?: 'Asc' | 'Desc';
    Name?: 'Asc' | 'Desc';
    SageId?: 'Asc' | 'Desc';
    IsActive?: 'Asc' | 'Desc';
    SubcontractorType?: 'Asc' | 'Desc';
    VendorType?: 'Asc' | 'Desc';
    UserCount?: 'Asc' | 'Desc';
  }>({
    Name: 'Asc'
  });
  const [page, setPage] = useState<number>(0);
  const [recordCount, setRecordCount] = useState<number>(0);
  const [perPage, setRowsPerPage] = useState<number>(10);
  const [selectedTypeId, setSelectedTypeId] = useState<string>('');
  const [selectedVendorTypeIds, setSelectedVendorTypeIds] = useState<string[]>([]);
  const [searchedValue, setSearchedValue] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  const [hasAppliedFilters, setHasAppliedFilters] = useState(false);
  const [filters, setFilters] = useState<{
    typeId?: number | string;
    vendorTypeIds?: string[];
  } | null>({});

  return (
    <ManageVendorPageContext.Provider
      value={{
        selectedSort,
        setSelectedSort,
        sortDirection,
        setSortDirection,
        page,
        setPage,
        perPage,
        setRowsPerPage,
        recordCount,
        setRecordCount,
        selectedTypeId,
        setSelectedTypeId,
        selectedVendorTypeIds,
        setSelectedVendorTypeIds,
        searchValue,
        setSearchedValue,
        setSearchValue,
        searchedValue,
        hasAppliedFilters,
        setHasAppliedFilters,
        filters,
        setFilters
      }}
    >
      {children}
    </ManageVendorPageContext.Provider>
  );
};
